import { MnosChips } from 'common/components/FilterChip/MnosChips.tsx';
import {
  rsimMnoNamesFilterAtom,
  rsimMobileNetworkOperatorFilterAtom,
  rsimMobileNetworkOperatorIdFilterAtom,
} from 'atoms/filters/rsim-products.ts';

export const RSimMnosChips = () => {
  return (
    <MnosChips
      mnoAtom={rsimMobileNetworkOperatorFilterAtom}
      mnoNamesFilterAtom={rsimMnoNamesFilterAtom}
      mnoIdFilterAtom={rsimMobileNetworkOperatorIdFilterAtom}
    />
  );
};
